import { FC, memo } from 'react';

import V2ContractsPresenter from './V2ContractsPresenter';

const V2Contracts: FC = memo(() => (
  <V2ContractsPresenter />
));

export default V2Contracts;
